import React, { useState } from 'react';
// Context
import { useLogsData } from '../../../context/LogsContext';
// Components
import DefaultTable from '../../../components/table/DefaultTable';
import { Column, Date } from '../../../components/table/components/Types';
import DefaultModal from '../../../components/modal/DefaultModal';
import PartnerIcons from './PartnerIcons';
import DefaultTooltip from '../../../components/tooltip/DefaultTooltip';
// Icons
import { FaPencilAlt } from 'react-icons/fa';
import LogForm from './LogForm';
// Enums
import { serviceOrigin, serviceOriginLabelTable, servicePartnerLabel } from '../../../utils/Enums';

const LogsTable = () => {
  // Context
  const { state } = useLogsData();

  // State
  const [showModal, setModalShow] = useState(false);
  const [log, setLog] = useState({});

  // Methods
  const handleShowModal = () => setModalShow(true);

  const handleCloseModal = () => setModalShow(false);

  const handleEditLog = (item) => {
    setLog(item);
    handleShowModal();
  };

  return (
    <>
      <DefaultTable
        data={state.data.items}
        isLoading={state.loading}
        headers={[
          {
            text: 'Cliente',
            colSpan: 8,
            headerClass: 'table--division table--cliente',
          },
          {
            text: 'Contrato',
            colSpan: 2,
            headerClass: 'table--division table--contact',
          },
          { text: 'Validado', colSpan: 3 },
        ]}
      >
        <Column
          header={'Parceiro'}
          accessor="partnerId"
          headerClass="table--partner-cell"
          render={(value, row) => {
            return (
              <>
                <PartnerIcons icon={row.serviceTypeId} />
                {servicePartnerLabel[value]}
              </>
            );
          }}
        />
        <Column header={'NIF'} accessor="subsidiaryVatNumber" headerClass="width-1 text-end" cellClassName="text-end" />
        <Column header={'Empresa'} accessor="subsidiaryCommercialDesignation" />
        <Column header={'Utilizador'} accessor="userName" />
        <Column header={'Contacto'} accessor="userCellphone" headerClass="width-1" />
        <Date header={'Registo'} accessor="startDate" />
        <Date header={'Submissão'} accessor="submissionDate" />
        <Column
          header={'Origem'}
          accessor="originId"
          headerClass="table--division"
          cellClassName="data--origin-type table--division"
          render={(value) => {
            return (
              <DefaultTooltip text={serviceOriginLabelTable[value].tip}>
                <span className={`${value === serviceOrigin.MANUAL ? 'type-manual' : 'type-site'}`}>
                  {serviceOriginLabelTable[value].label}
                </span>
              </DefaultTooltip>
            );
          }}
        />
        <Date header={'Inicio'} accessor="agreementDate" />
        <Column
          header={'Benefício (€)'}
          accessor="benefitValue"
          headerClass="table--division text-end text-nowrap"
          cellClassName="table--division text-end"
        />
        <Date header={'Data'} accessor="validationDate" />
        <Column
          header={'Comercial'}
          accessor="validationBy"
          render={(value) => {
            return (
              <span className="text-capitalize">
                {value ? value.replace(/IMP-WEB01\\/, '').replace(/\./g, ' ') : ''}
              </span>
            );
          }}
        />
        <Column
          header={'Ações'}
          render={(value, item) => {
            return (
              <div className="table--action">
                <span onClick={() => handleEditLog(item)}>
                  <FaPencilAlt />
                </span>
              </div>
            );
          }}
        />
      </DefaultTable>
      <DefaultModal title={'Editar'} showModal={showModal} handleCloseModal={handleCloseModal}>
        <LogForm log={log} handleCloseModal={handleCloseModal} />
      </DefaultModal>
    </>
  );
};

export default LogsTable;
